import Container from "./Containers/Container";

const Customers = {
    Container,
}

export { Customers }